import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["section", "dot"]

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => this.#handleIntersection(entries),
      { threshold: 0.3 }
    )

    this.sectionTargets.forEach((section) => this.observer.observe(section))
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #handleIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      const index = this.sectionTargets.indexOf(entry.target)
      if (index === -1) return

      this.dotTargets.forEach((dot, i) => {
        dot.classList.toggle("bg-warm-500", i === index)
        dot.classList.toggle("text-white", i === index)
        dot.classList.toggle("bg-gray-200", i !== index)
        dot.classList.toggle("text-gray-400", i !== index)
        dot.classList.toggle("dark:bg-gray-600", i !== index)
        dot.classList.toggle("dark:text-gray-400", i !== index)
      })
    })
  }
}
